<template>
  <div class="home">
    <div id="progress" v-if="loadingFinished === false"
      style="position: fixed; width: 200px; left: calc(50% - 100px); top: 20px; padding: 5px 0; background-color: rgba(255,255,255,.7); z-index: 1000; border-radius: 5px; box-shadow: 0 2px 4px rgba(0,0,0,0.3);">
      <div id="progress-bar" style="display: flex;justify-content: center;align-items: center;width: 200px;">已加载:{{
        loaded + "MB" }}
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'; // Importing Three.js for 3D rendering
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'; // Importing OrbitControls for camera control
import { MapControls } from 'three/addons/controls/MapControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'; // Importing GLTFLoader for loading 3D models
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js'; // Importing GUI for user interface controls
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js'; // Importing RGBELoader for loading HDR textures
import { WebGLPathTracer } from 'three-gpu-pathtracer';


export default {
  name: 'HomeView',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App', // This is a placeholder message  
      loaded: 0, // progress of the model loading
      loadingFinished: false // flag to indicate if loading is finished
    };
  },
  mounted() {
    let timeout = undefined;
    const scene = new THREE.Scene(); // Creating a new scene
    window.scene = scene; // Exposing the scene globally for debugging
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.01, 5000); // Setting up the camera with a perspective view
    window.camera = camera; // Exposing the camera globally for debugging
    const renderer = new THREE.WebGLRenderer(
      { antialias: true, logarithmicDepthBuffer: true } // Enabling anti-aliasing for smoother edges
    ); // Creating a WebGL renderer
    window.renderer = renderer; // Exposing the renderer globally for debugging
    renderer.setSize(window.innerWidth, window.innerHeight); // Setting the size of the renderer
    //set tonemapping
    renderer.toneMapping = THREE.ACESFilmicToneMapping; // Setting the tone mapping to ACES Filmic for better color grading
    renderer.toneMappingExposure = 0.5; // Setting the exposure for tone mapping
    document.body.appendChild(renderer.domElement); // Appending the renderer to the document body
    camera.near = 0.1; // Adjusting the near plane of the camera
    camera.far = 10000; // Adjusting the far plane of the camera
    camera.position.set(-147, 491, -71); // Setting the initial position of the camera
    // Adding orbit controls for camera manipulation
    const controls = new MapControls(camera, renderer.domElement); // Adding orbit controls for camera manipulation
    controls.autoRotate = false; // Disabling auto-rotation of the camera
    controls.minDistance = 0.1; // Setting the minimum distance for the camera
    controls.maxDistance = 1000; // Setting the maximum distance for the camera
    controls.enableDamping = true; // Enabling damping for smoother camera movement
    controls.dampingFactor = 0.3; // Setting the damping factor for smoother camera movement
    controls.mouseButtons = {
      LEFT: THREE.MOUSE.ROTATE,
      MIDDLE: THREE.MOUSE.DOLLY,
      RIGHT: THREE.MOUSE.PAN
    }
    controls.addEventListener('start', function () {
      //console.log('Camera position:', camera.position); // Logging the camera position on change
      controls.autoRotate = false;
      clearTimeout(timeout);
    });
    controls.addEventListener('end', function () {
      timeout = setTimeout(() => { controls.autoRotate = false }, 5000)
    });
    const loader = new GLTFLoader(); // Creating a GLTF loader instance
    loader.load('/Models/airport.glb',
      (glb) => {         // Loading a GLTF model
        this.loadingFinished = true;
        glb.scene.traverse((child) => { // Traversing through the loaded model's children
          if (child.isMesh) { // Checking if the child is a mesh
            child.castShadow = true; // Enabling shadow casting for the mesh
            child.receiveShadow = true; // Enabling shadow receiving for the mesh
          }
        });
        scene.add(glb.scene); // Adding the loaded model to the scene

        console.log('Model loaded successfully'); // Logging success message
        setTimeout(() => { // translate the camera position smoothly to the positon (129,15,-19)
          directionalLight.shadow.autoUpdate = false; // Disabling automatic shadow updates for performance
          let targetPosition = new THREE.Vector3(118, 18, -133); // Defining the target position for the camera
          let duration = 50000; // Duration for the camera movement in milliseconds
          let startTime = performance.now(); // Getting the current time for the animation start
          function animateCamera() { // Function to animate the camera movement
            let elapsedTime = performance.now() - startTime; // Calculating the elapsed time since the start of the animation
            let t = Math.min(elapsedTime / duration, 1); // Calculating the interpolation factor
            camera.position.lerpVectors(camera.position.clone(), targetPosition, t); // Interpolating the camera position towards the target position
            camera.lookAt(new THREE.Vector3(193, 0, -38)); // Making the camera look at the origin
            controls.target.copy(new THREE.Vector3(193, 0, -38)); // Updating the controls target to the origin
            // Updating the controls to reflect the new camera position and orientation
            controls.update();

            if (camera.position.distanceTo(targetPosition) > 1) { // Checking if the current camera position to target position is close than 1
              requestAnimationFrame(animateCamera); // Requesting the next frame for animation
              timeout = setTimeout(() => { controls.autoRotate = false }, 5000)
            } else {
              console.log('Camera position updated to:', camera.position); // Logging the updated camera position
            }
          }
          animateCamera(); // Starting the camera animation

        }, 1000); // Delay of 1000 milliseconds (1 second)
      },
      (xhr) => { // Function to track loading progress
        this.loaded = (xhr.loaded / 1024 / 1024).toFixed(2) // Updating the progress percentage
        document.getElementById('progress-bar').style.width = this.progress + '%'; // Updating the progress bar width
        if (this.progress === 100) { // Hiding the progress bar when loading is complete
          setTimeout(() => {
            document.getElementById('progress').style.display = 'none';
          }, 500); // Delay of 500 milliseconds before hiding the progress bar
        }

      }, function (error) { // Handling errors during loading
        console.error(error);
      });
    //create cubemap for the scene
    const cubeTextureLoader = new THREE.CubeTextureLoader(); // Creating a CubeTextureLoader instance
    const texture = cubeTextureLoader.load([ // Loading a cube texture for the scene
      '/images/Epic_BlueSunset_Cam_2_Left+X.jpg', // Positive X
      '/images/Epic_BlueSunset_Cam_3_Right-X.jpg', // Negative X
      '/images/Epic_BlueSunset_Cam_4_Up+Y.jpg', // Positive Y
      '/images/Epic_BlueSunset_Cam_5_Down-Y.jpg', // Negative Y
      '/images/Epic_BlueSunset_Cam_0_Front+Z.jpg', // Positive Z
      '/images/Epic_BlueSunset_Cam_1_Back-Z.jpg' // Negative Z
    ]); // Loading the cube texture
    scene.background = texture; // Setting the scene's background to the loaded cube texture
    scene.backgroundRotation.y = -0.9
    //load exr texture for environment mapping
    const exrLoader = new EXRLoader(); // Creating an RGBELoader instance
    exrLoader.load('/images/city.exr', (exr) => { // Loading an EXR texture
      exr.mapping = THREE.EquirectangularReflectionMapping; // Setting the mapping type for the texture
      scene.environment = texture; // Setting the scene's environment to the loaded EXR texture
      exr.colorSpace = THREE.SRGBColorSpace; // Setting the color space for the texture
      exr.needsUpdate = true; // Marking the  texture as needing an update
    }, undefined, (error) => { // Handling errors during loading
      console.error('An error occurred while loading the EXR texture:', error);
    }); // End of EXR texture loading
    //add environmental lighting
    const hemisphereLight = new THREE.HemisphereLight(0xfffff3, 0xeeeee3, 0); // Adding ambient light to the scene
    scene.add(hemisphereLight); // Adding ambient light to the scene
    const directionalLight = new THREE.DirectionalLight(0xfffff3, 20); // Adding directional light
    directionalLight.position.set(-100, 220, 100); // Setting the position of the directional light
    directionalLight.castShadow = true; // Enabling shadow casting for the directional light
    directionalLight.shadow.mapSize.width = 4096 * 2; // Setting the shadow map size
    directionalLight.shadow.mapSize.height = 4096 * 2; // Setting the shadow map size
    directionalLight.shadow.camera.near = 0.1; // Setting the near plane for the shadow camera
    directionalLight.shadow.camera.far = 1000; // Setting the far plane for the shadow
    directionalLight.shadow.camera.left = -300; // Setting the left boundary for the shadow camera
    directionalLight.shadow.camera.right = 300; // Setting the right boundary for the shadow camera
    directionalLight.shadow.camera.top = 300; // Setting the top boundary for the shadow camera
    directionalLight.shadow.camera.bottom = -300; // Setting the bottom boundary for the shadow camera
    directionalLight.shadow.bias = -0.001; // Setting the shadow bias to reduce artifacts
    directionalLight.shadow.normalBias = 0.001; // Setting the normal bias for the shadow

    scene.add(directionalLight); // Adding directional light to the scene
    // const helper = new THREE.CameraHelper(directionalLight.shadow.camera);
    // scene.add(helper);
    //set all objects to cast and receive shadows
    scene.traverse((object) => { // Traversing through all objects in the scene
      if (object.isMesh) { // Checking if the object is a mesh
        object.castShadow = true; // Enabling shadow casting for the mesh
        object.receiveShadow = true; // Enabling shadow receiving for the mesh
      }
    }); // End of object traversal
    renderer.shadowMap.enabled = true; // Enabling shadow mapping in the renderer
    renderer.shadowMap.type = THREE.PCFSoftShadowMap; // Setting the shadow map type for softer shadows
    // add controls for the lights to control the intensity and position and target of the lights
    const lightControls = {
      hemisphereLightIntensity: hemisphereLight.intensity,
      directionalLightIntensity: 1,
      directionalLightPositionX: directionalLight.position.x,
      directionalLightPositionY: directionalLight.position.y,
      directionalLightPositionZ: directionalLight.position.z,
      directionalLightTargetX: 160,
      directionalLightTargetY: 0,
      directionalLightTargetZ: -100,
      bias: directionalLight.shadow.bias, // Adding a control for shadow bias
      toneMapping: renderer.toneMapping, // Adding a control for tone mapping
      toneMappingExposure: 1.3 // Adding a control for tone mapping exposure
    };
    // Function to update light properties based on controls
    function updateLights() {
      hemisphereLight.intensity = lightControls.hemisphereLightIntensity;
      directionalLight.intensity = lightControls.directionalLightIntensity;
      directionalLight.position.set(lightControls.directionalLightPositionX,
        lightControls.directionalLightPositionY,
        lightControls.directionalLightPositionZ);
      // Update the target of the directional light
      directionalLight.target.position.set(lightControls.directionalLightTargetX,
        lightControls.directionalLightTargetY,
        lightControls.directionalLightTargetZ);
      directionalLight.target.updateMatrixWorld(); // Updating the target's matrix world to reflect changes
      directionalLight.shadow.bias = lightControls.bias; // Updating the shadow bias
      renderer.toneMapping = lightControls.toneMapping; // Updating the renderer's tone mapping
      renderer.toneMappingExposure = lightControls.toneMappingExposure; // Updating the renderer's
      renderer.shadowMap.needsUpdate = true; // Marking the shadow map as needing an update
    }
    // const gui = new GUI(); // Creating a GUI instance
    // gui.add(lightControls, 'hemisphereLightIntensity', 0, 100).onChange(updateLights); // Adding a control for ambient light intensity
    // gui.add(lightControls, 'directionalLightIntensity', 0, 100).onChange(updateLights); // Adding a control for directional light intensity
    // gui.add(lightControls, 'directionalLightPositionX', -1000, 1000).onChange(updateLights); // Adding a control for directional light X position
    // gui.add(lightControls, 'directionalLightPositionY', -1000, 1000).onChange(updateLights); // Adding a control for directional light Y position
    // gui.add(lightControls, 'directionalLightPositionZ', -1000, 1000).onChange(updateLights); // Adding a control for directional light Z position
    // gui.add(lightControls, 'directionalLightTargetX', -1000, 1000).onChange(updateLights); // Adding a control for directional light target X position
    // gui.add(lightControls, 'directionalLightTargetY', -1000, 100).onChange(updateLights); // Adding a control for directional light target Y position
    // gui.add(lightControls, 'directionalLightTargetZ', -1000, 1000).onChange(updateLights); // Adding a control for directional light target Z position
    // gui.add(lightControls, 'bias', -0.001, 0).onChange(updateLights); // Adding a control for shadow bias
    // gui.add(lightControls, 'toneMapping', {
    //   NoToneMapping: THREE.NoToneMapping,
    //   LinearToneMapping: THREE.LinearToneMapping,
    //   ReinhardToneMapping: THREE.ReinhardToneMapping,
    //   CineonToneMapping: THREE.CineonToneMapping,
    //   ACESFilmicToneMapping: THREE.ACESFilmicToneMapping,
    //   CustomToneMapping: THREE.CustomToneMapping
    // }).onChange(updateLights); // Adding a control for tone mapping
    // gui.add(lightControls, 'toneMappingExposure', 0, 10).onChange(updateLights); // Adding a control for tone mapping exposure
    // Handling window resize events to adjust camera and renderer
    window.addEventListener('resize', () => { // Adding an event listener for window resize
      camera.aspect = window.innerWidth / window.innerHeight; // Adjusting the camera aspect ratio
      camera.updateProjectionMatrix(); // Updating the camera's projection matrix
      renderer.setSize(window.innerWidth, window.innerHeight); // Adjusting the renderer size
    }); // End of window resize event listener
    // Animation loop to render the scene
    function animate() {
      renderer.render(scene, camera); // Rendering the scene from the camera's perspective
      controls.update(); // Updating the controls for smooth interaction
      updateLights(); // Updating the lights based on GUI controls
      requestAnimationFrame(animate); // Requesting the next frame for animation
    }
    animate(); // Starting the animation loop
    console.log('Animation loop started'); // Logging that the animation loop has started
    // @ is an alias to /src
  }
}
</script>
